export default {
    HOMEPAGE: 'public-homepage',
    MESSAGE: 'messages',
    MESSAGE_CONTACT: 'contact',
    MESSAGE_REFERENT_HANDICAP: 'referent-handicap',
    EMAIL_REGENERATE: 'public-regenerate-email',
    EMAIL_CHECK: 'public-email-check',
    MAINTENANCE: 'public-maintenance',
    EXTERNAL_LINK_HELP_CANDIDAT: 'public-help-candidature',
    EXTERNAL_LINK_CONTACT: 'public-help-contact',
    EXTERNAL_LINK_FACEBOOK: 'public-facebook',
    EXTERNAL_LINK_INSTAGRAM: 'public-instagram',
    EXTERNAL_LINK_LINKEDIN: 'public-linkedin',
    EXTERNAL_LINK_HELP_INSCRIPTION: 'public-help-inscription',
    LOGIN: 'public-login',
    PASSWORD_FORGET: 'public-forget-password',
    PASSWORD_REGENERATE: 'public-regenerate-password',
    REGISTER_APPROACH: 'public-register-approach',
    REGISTER_CONDITIONS: 'public-register-conditions',
    REGISTER: 'public-register',
    REGISTER_FORM: 'public-register-form',
    REGISTER_SUCCESS: 'public-register-success',
    TEST_COMMENCER: 'questionnaire',
    TEST_QUESTION: 'question',
    CANDIDACY_FILE: 'file',
    CANDIDACY_TESTS: 'mes-tests',
    CANDIDACY_INFO_PERSONAL: 'ma-candidature-1',
    CANDIDACY_INFO_PROFESSIONAL: 'ma-candidature-2',
    CANDIDACY_REGISTRATION: 'ma-candidature-3',
    PLANNING_LOGIN: 'PlanningLogin',
    PLANNING_VIEW: 'PlanningView',
    PLANNING_LIST: 'PlanningList',
    MEETING_LIST: 'MeetingList',
    MEETING_CONFIRMATION: 'MeetingConfirmation',
    DASHBOARD: 'dashboard',
    PROFIL: 'profil',

}
